<script setup lang="ts">

import {ref} from "vue";
import axios from "axios";
import {router} from "@inertiajs/vue3";

const isDialogOpen = ref(false)

const disableTwoFactorAuthentication = () => {
    axios.delete('/user/two-factor-authentication')
        .then(() => {
            router.reload({
                only: ['twoFactorEnabled']
            })
        })
}
</script>

<template>
    <v-dialog
        v-model="isDialogOpen"
        max-width="500"
        scrim="grey"
    >
        <template #activator="{ props: attrs }">
            <error-btn
                v-bind="attrs"
                class="mt-5"
                border="sm"
                rounded="lg"
            >
                Disable two-factor authentication
            </error-btn>
        </template>

        <v-card
            :flat="true"
            rounded="lg"
            class="border"
            min-width="600"
        >
            <v-card-title class="font-weight-bold text-body-2 pb-0 border-b">
                Are you sure you want to disable two-factor authentication?
                <v-btn
                    variant="flat"
                    size="x-small"
                    icon="mdi-close"
                    class="float-end"
                    rounded="lg"
                    @click="isDialogOpen = false"
                />
            </v-card-title>

            <v-card-text class="pa-4 text-body-2">
                <p>Two-factor authentication adds an additional layer of security to your account by requiring more than just a password to sign in.</p>
                <br>
                <p>SendCrypt highly recommends that you keep two-factor authentication enabled on your account. If you need to change your configuration, or generate new recovery codes, you can do that in the settings below.</p>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <default-btn
                    @click="isDialogOpen = false"
                >
                    Cancel
                </default-btn>
                <default-btn
                    class="text-error"
                    @click="disableTwoFactorAuthentication"
                >
                    Disable
                </default-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style scoped>

</style>
